function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".logo-background_svg__cls-1{fill:#fbf3f3}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "logo-background_svg__Group_13",
  "data-name": "Group 13",
  transform: "translate(-28 -184)"
}, React.createElement("g", {
  id: "logo-background_svg__Group_2",
  "data-name": "Group 2",
  transform: "translate(28 184)"
}, React.createElement("circle", {
  id: "logo-background_svg__Ellipse_1",
  "data-name": "Ellipse 1",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_2",
  "data-name": "Ellipse 2",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(26.791)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_3",
  "data-name": "Ellipse 3",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(52.243)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_4",
  "data-name": "Ellipse 4",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(77.695)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_5",
  "data-name": "Ellipse 5",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(103.146)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_6",
  "data-name": "Ellipse 6",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(128.598)"
})), React.createElement("g", {
  id: "logo-background_svg__Group_3",
  "data-name": "Group 3",
  transform: "translate(28 209.452)"
}, React.createElement("circle", {
  id: "logo-background_svg__Ellipse_1-2",
  "data-name": "Ellipse 1",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_2-2",
  "data-name": "Ellipse 2",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(26.791)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_3-2",
  "data-name": "Ellipse 3",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(52.243)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_4-2",
  "data-name": "Ellipse 4",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(77.695)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_5-2",
  "data-name": "Ellipse 5",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(103.146)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_6-2",
  "data-name": "Ellipse 6",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(128.598)"
})), React.createElement("g", {
  id: "logo-background_svg__Group_4",
  "data-name": "Group 4",
  transform: "translate(28 234.903)"
}, React.createElement("circle", {
  id: "logo-background_svg__Ellipse_1-3",
  "data-name": "Ellipse 1",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_2-3",
  "data-name": "Ellipse 2",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(26.791)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_3-3",
  "data-name": "Ellipse 3",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(52.243)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_4-3",
  "data-name": "Ellipse 4",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(77.695)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_5-3",
  "data-name": "Ellipse 5",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(103.146)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_6-3",
  "data-name": "Ellipse 6",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(128.598)"
})), React.createElement("g", {
  id: "logo-background_svg__Group_5",
  "data-name": "Group 5",
  transform: "translate(28 260.355)"
}, React.createElement("circle", {
  id: "logo-background_svg__Ellipse_1-4",
  "data-name": "Ellipse 1",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_2-4",
  "data-name": "Ellipse 2",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(26.791)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_3-4",
  "data-name": "Ellipse 3",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(52.243)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_4-4",
  "data-name": "Ellipse 4",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(77.695)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_5-4",
  "data-name": "Ellipse 5",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(103.146)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_6-4",
  "data-name": "Ellipse 6",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(128.598)"
})), React.createElement("g", {
  id: "logo-background_svg__Group_6",
  "data-name": "Group 6",
  transform: "translate(28 285.807)"
}, React.createElement("circle", {
  id: "logo-background_svg__Ellipse_1-5",
  "data-name": "Ellipse 1",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_2-5",
  "data-name": "Ellipse 2",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(26.791)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_3-5",
  "data-name": "Ellipse 3",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(52.243)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_4-5",
  "data-name": "Ellipse 4",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(77.695)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_5-5",
  "data-name": "Ellipse 5",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(103.146)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_6-5",
  "data-name": "Ellipse 6",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(128.598)"
})), React.createElement("g", {
  id: "logo-background_svg__Group_7",
  "data-name": "Group 7",
  transform: "translate(28 311.258)"
}, React.createElement("circle", {
  id: "logo-background_svg__Ellipse_1-6",
  "data-name": "Ellipse 1",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_2-6",
  "data-name": "Ellipse 2",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(26.791)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_3-6",
  "data-name": "Ellipse 3",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(52.243)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_4-6",
  "data-name": "Ellipse 4",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(77.695)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_5-6",
  "data-name": "Ellipse 5",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(103.146)"
}), React.createElement("circle", {
  id: "logo-background_svg__Ellipse_6-6",
  "data-name": "Ellipse 6",
  className: "logo-background_svg__cls-1",
  cx: 9.377,
  cy: 9.377,
  r: 9.377,
  transform: "translate(128.598)"
})));

var SvgLogoBackground = function SvgLogoBackground(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 147.352 146.012"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,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";
export { SvgLogoBackground as ReactComponent };